import {orgInfoApi} from '../api';
import {IDeleteDataOrgInfoArgs, IPostDataOrgInfoArgs, IPutDataOrgInfoArgs} from '../api/types';
import {IGetDataArgs} from '../model/types';

export const OrgInfoTabService = {
    get: async (args?: IGetDataArgs) => {
        try {
            return await orgInfoApi.getData(args);
        } catch (error) {
            throw new Error(error);
        }
    },

    post: async (args: IPostDataOrgInfoArgs) => {
        try {
            const response = await orgInfoApi.postData(args);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },

    put: async (args: IPutDataOrgInfoArgs) => {
        try {
            return await orgInfoApi.putData(args);
        } catch (error) {
            throw new Error(error);
        }
    },

    delete: async (rowsIds: IDeleteDataOrgInfoArgs) => {
        try {
            return await orgInfoApi.deleteData(rowsIds);
        } catch (error) {
            throw new Error(error);
        }
    },
};
